import React from "react";
import { Typography } from "@mui/material";
import DemoInputInfoLink from "./DemoInputInfoLink";

// デモ（TOPページ埋め込み）の入力情報の取扱いに関する注意書き。
export default function DemoInputInfoNote() {
  return (
    <Typography
      component="p"
      sx={{
        mt: 3,
        fontSize: "0.75rem",
        lineHeight: 1.9,
        color: "#94a3b8",
        // スマホは左揃え（多行の注意文が読みやすい）、PC は中央
        textAlign: { xs: "left", sm: "center" },
      }}
    >
      入力内容は、この端末・ブラウザに自動保存されます。PDFの生成時のみ、入力内容を当社サーバーへ一時的に送信します。
      <br />
      入力内容はデータベースには保存されません。本登録後にスキルシートへ引き継がれます。別端末・別ブラウザには引き継げません。
      <br />
      <DemoInputInfoLink />
    </Typography>
  );
}
